import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import SponsorArea from '../ads/SponsorArea';
import { generateStyles } from '../../utils/DOMUtils';

/**
 * Class representing section headings for the site
 *
 * For the sponsored section in the config it should look something like (note it should not have both 'link' and 'ad)
 *
 * "sponsor": {
      "label": "Sponsored by ",

      "link": {
        "imageUri": "",
        "uri": ""
      },

      // OR:

      "ad": {
        "options":{
          "id": 156,
          "wncc": "homepage",
          "width": 120,
          "height": 30,
          "ownerinfo": {
            "loc": {
              "share": 1
            }
          },
          "screensizes": [
            [ [0, 0], [120, 30] ]
          ]
        }
      }
    }
 */

const TITLE_TYPE = {
  PAGE_TITLE: 'page-title'
};

const TITLE_MODE = {
  manual: 'manual',
  feed: 'feed'
};

class PageTitle extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    mainTitle: PropTypes.string,
    secondaryTitle: PropTypes.string,
    sponsor: PropTypes.object,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    destinationUrl: PropTypes.string,
    urlTarget: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
    linkStyle: PropTypes.shape({
      color: PropTypes.string,
      textDecoration: PropTypes.string
    }),
    visitedStyle: PropTypes.shape({
      color: PropTypes.string,
      textDecoration: PropTypes.string
    }),
    hoverStyle: PropTypes.shape({
      color: PropTypes.string,
      textDecoration: PropTypes.string
    }),
    activeStyle: PropTypes.shape({
      color: PropTypes.string,
      textDecoration: PropTypes.string
    }),
    titleType: PropTypes.string,
    mode: PropTypes.oneOf(Object.keys(TITLE_MODE)),
    mainDataPath: PropTypes.string
  }

  static defaultProps = {
    mode: TITLE_MODE.manual,
    mainDataPath: 'headline'
  }

  state = {
    pageTitleDomId: _.uniqueId('PageTitle')
  }

  // Function to Check titleType
  // Return true if titleType is "page-title" else return false
  _checkPageTitle(titleType) {
    const title = titleType.toLowerCase().trim().replace(' ', '-');
    return title === TITLE_TYPE.PAGE_TITLE;
  }

  render() {
    const {
      FRN_rawResponses = [],
      mainTitle = '',
      secondaryTitle: subTitle = '',
      backgroundColor = '#fff',
      textColor,
      sponsor = null,
      destinationUrl,
      urlTarget = '_blank',
      linkStyle: {
        color: linkColor = '',
        textDecoration: linkTextDecoration = ''
      } = {},
      visitedStyle: {
        color: visitedColor = '',
        textDecoration: visitedTextDecoration = ''
      } = {},
      hoverStyle: {
        color: hoverColor = '',
        textDecoration: hoverTextDecoration = ''
      } = {},
      activeStyle: {
        color: activeColor = '',
        textDecoration: activeTextDecoration = ''
      } = {},
      titleType = '',
      mode = '',
      mainDataPath = ''
    } = this.props;

    const {
      pageTitleDomId
    } = this.state;

    let customComponentStyles = {};
    let pageTitleSponsor;

    const pageTitleStyles = generateStyles('#' + pageTitleDomId, [
      {
        selector: 'a:link',
        styles: 'color: ' + linkColor + ';' + 'text-decoration: ' + linkTextDecoration + ';'
      },
      {
        selector: 'a:visited',
        styles: 'color: ' + visitedColor + ';' + 'text-decoration: ' + visitedTextDecoration + ';'
      },
      {
        selector: 'a:hover',
        styles: 'color: ' + hoverColor + ';' + 'text-decoration: ' + hoverTextDecoration + ';'
      },
      {
        selector: 'a:active',
        styles: 'color: ' + activeColor + ';' + 'text-decoration: ' + activeTextDecoration + ';'
      }
    ]);

    if (sponsor) {
      const { link = {}, ad, label = '' } = sponsor;

      if (ad || link.imageUri) {
        pageTitleSponsor = (
          <div className="PageTitle-sponsorComponent">
            {link.imageUri && <span className="PageTitle-sponsorLabel">{label}</span>}
            <SponsorArea sponsor={sponsor} />
          </div>);
      }
    }

    customComponentStyles['backgroundColor'] = backgroundColor;
    if (textColor) {
      customComponentStyles['color'] = textColor;
    }
    const isPageTitle = this._checkPageTitle(titleType);

    const feedMode = mode === TITLE_MODE.feed;
    const primaryTitle = feedMode ? _.get(FRN_rawResponses[0], `data.${mainDataPath}`, '') : mainTitle;
    const secondaryTitle = feedMode ? '' : subTitle;

    if (!primaryTitle && !secondaryTitle) {
      return null;
    }

    const genTitle = () => (
      <div style={customComponentStyles}>
        <span className="PageTitle-mainText">
          {destinationUrl ? <a href={destinationUrl} target={urlTarget}>{primaryTitle}</a> : primaryTitle }
        </span>
        &nbsp;
        <span className="PageTitle-secondaryText">
          {destinationUrl ? <a href={destinationUrl} target={urlTarget}>{secondaryTitle}</a> : secondaryTitle }
        </span>
      </div>
    );
    return (
      <div className="PageTitle" id={pageTitleDomId} style={customComponentStyles}>
        { isPageTitle 
          ? <h1 className='PageTitle-text'>{genTitle()}</h1> 
          : <h2 className='PageTitle-text'>{genTitle()}</h2>
        }
        { pageTitleSponsor }
        <style>
          { pageTitleStyles }
        </style>  
      </div>
    );
  }

}

export default PageTitle;



// WEBPACK FOOTER //
// ./app/components/shared/PageTitle.js